import styled from "styled-components"
export const Wrapper = styled.form`
    width: 100%;
    padding:30px 0;
    text-align: center;
`